export default "__VITE_ASSET__CGGCZPCI__"